/* eslint-disable sort-imports */
import '@config';
import Hero from './blocks/hero';
import Header from './components/header';
import Marquee from './components/marquee';
import NavMain from './components/navMain';
import Router from './components/router';
import UserJourney from './blocks/userJourney.js';
import FormHubSpot from './components/formHubSpot';

document.addEventListener('DOMContentLoaded', () => {
  const router = new Router([
    // Preserve order
    new Header(),
    new NavMain(),

    // End preserve order
    new Marquee(),
    new Hero(),
    new UserJourney(),
    new FormHubSpot(),
  ]);

  router.bootstrap();
});
